<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <div class="header-button" />
    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table :data="questions">
      <el-table-column
        prop="no"
        label="订单号"
          min-width="120"
      />

      <el-table-column
        prop="nickname"
        label="姓名"
          min-width="120"
      />
      <el-table-column
        prop="mobile"
        label="手机号"
          min-width="120"
      />

      <el-table-column
        prop="area_name"
        label="区域"
          min-width="120"
      />
      <el-table-column
        prop="pay_money"
        :show-overflow-tooltip="true"
        label="退款金额"
          min-width="120"
      />

      <el-table-column
        label="是否成功"
        align="center"
         min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.pay_status == 1"
            type="success"
          >成功</el-tag>
          <el-tag
            v-else
            type="danger"
          >失败</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="created_at"
        label="创建时间"
        min-width="120"
      />
      <el-table-column
        label="操作"
        fixed="right"
        width="250"
      >
        <template #default="{ row, $index }">
          <el-button
            @click="detailClick(row)"
            type="success"
          > 查询结果</el-button>
          <el-button
            @click="tryAgain(row)"
            v-show="row.try_again"
            type="danger"
          > 重试</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import {
  refundBalanceOrders,
  queryRefundBalance,
  refundBalanceAgain
} from "@/api/users";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "pay_status",
          label: "是否成功",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 0,
              name: "失败"
            },
            {
              id: 1,
              name: "成功"
            }
          ]
        },
        {
          type: "super-input",
          field: "mobile_nickname",
          label: "用户手机号"
        },
        {
          field: "no",
          label: "订单号"
        }
      ],
      questions: [],
      page: null,
      first_blood: true,
      areas: []
    };
  },
  inject: ["reload"],
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);
        const {
          data: { data, meta }
        } = await refundBalanceOrders(newVal.query);
        this.questions = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  async created() {
   
    // console.log(11)
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);

    this.areas.push.apply(this.areas, areas);
    this.search[0].options.push.apply(this.search[0].options, areas);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
       if (env.isPosSwitch == true) {
      this.search.push({
        type: "el-select",
        field: "merchant_id",
        label: "商户",
        options: [
          {
            id: "",
            name: "全部"
          }
        ]
      });
      this.search[4].options.push.apply(this.search[4].options, merchant.data);
    }
    }
  },
  methods: {
    async detailClick(row, index) {
      await queryRefundBalance({ no: row.no }).then(res => {
        res.then(data => {
          this.$message({
            message: data.data,
            type: "success"
          });
          this.reload();
        });
      });
    },
    async tryAgain(row) {
      await refundBalanceAgain({ no: row.no }).then(res => {
        res.then(data => {
          this.$message({
            message: data.data,
            type: "success"
          });
          this.reload();
        });
      });
    }
  }
};
</script>
<style lang="scss" scope>
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
.limitwidth {
  width: 40%;
  margin-right: 10px;
}
</style>
